import { z } from './zod.ts';

/** Ответ `GET /version`: версия сборки и git SHA (SPEC 9.4, ABOUT-1). */
export const versionInfoSchema = z.object({
  version: z.string().min(1),
  gitSha: z.string().min(1),
});

export type VersionInfo = z.infer<typeof versionInfoSchema>;
